import axios from 'axios';
import LoginService from '../services/LoginService.js'

export default class CarParkService {

  listCarparks(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/carpark/api/v1/carparks",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      } 
      else
        return error.response
    });
  }

}
